import { render } from "./Item.vue?vue&type=template&id=10d316cf&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"

import "./Item.vue?vue&type=style&index=0&id=10d316cf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-10d316cf"

export default script